import {
  Component,
  OnInit,
  ViewChild,
  Input,
  SimpleChanges,
  ComponentFactoryResolver,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
import { _ } from 'underscore';
import { InterfaceComponent } from '../../../questionarie-signup/questionnaire-residential/interface-component';
import { AddComponent } from '../../../questionarie-signup/questionnaire-residential/add-component';
import { CommercialDirective } from '../commercial.directive';
import { CommercialService } from '../commercial.service';
import {
  ScrollToService,
  ScrollToConfigOptions,
} from '@nicky-lenaers/ngx-scroll-to';

@Component({
  selector: 'app-commercial-questionnaire',
  templateUrl: './commercial-questionnaire.component.html',
  styleUrls: ['./commercial-questionnaire.component.css'],
})
export class CommercialQuestionnaireComponent implements OnInit {
  @ViewChild(CommercialDirective, { static: true })
  appCommercial: CommercialDirective;
  @Input() questions: AddComponent[];
  question: AddComponent[];
  deviceWidth;
  message;
  currentId;
  userResponses;
  showBack = false;
  previous;
  showThunder = false;
  selectedServiceType;
  showNextId = false;
  showProgress = false;

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler($event) {
    $event.returnValue = false;
    const currentId = this.commercialService.currentId;
    sessionStorage.setItem('skipId', currentId);
    const obj = {
      addAddress: this.commercialService.addAddress,
      serialNo: this.commercialService.serialNumber,
      modify: this.commercialService.modifyAddress,
    };
    sessionStorage.setItem('addAddress', JSON.stringify(obj));
  }

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private commercialService: CommercialService,
    private cd: ChangeDetectorRef,
    private _scrollToService: ScrollToService
  ) {
    this.deviceWidth = window.innerWidth;
    this.commercialService.deviceWidth = this.deviceWidth;
    if (!_.isEmpty(sessionStorage.getItem('commercialResponses'))) {
      this.userResponses = JSON.parse(
        sessionStorage.getItem('commercialResponses')
      ).userResponses;
      this.commercialService.userResponse.userResponses = this.userResponses;
      this.commercialService.filter(this.userResponses);
    }
    if (!_.isEmpty(sessionStorage.getItem('skipId'))) {
      this.commercialService.currentId = sessionStorage.getItem('skipId');
    }
    if (!_.isEmpty(sessionStorage.getItem('addAddress'))) {
      const obj = JSON.parse(sessionStorage.getItem('addAddress'));
      this.commercialService.addAddress = obj.addAddress;
      this.commercialService.serialNumber = obj.serialNo;
      this.commercialService.modifyAddress = obj.modify;
    }
  }

  ngOnInit() {
    this.commercialService.currentunSelect.subscribe((message) => {
      if (!_.isEmpty(message)) {
        const viewContainerRef = this.appCommercial.viewContainerRef;
        const containerLength = viewContainerRef.length;
        const question = _.findWhere(this.question, {
          _id: message['currentId'],
        });
        let initial = this.question.indexOf(question) + 1;
        if (containerLength > initial) {
          for (let i = initial; i < containerLength; i++) {
            viewContainerRef.remove(i);
            this.cd.detach();
            if (!this.cd['destroyed']) {
              this.cd.detectChanges();
            }
          }
        }
      }
    });

    this.commercialService.currentMessage.subscribe((message) => {
      this.userResponses = this.commercialService.userResponse.userResponses;
      if (!_.isEmpty(this.userResponses) && this.userResponses.length > 1) {
        this.commercialService.filter(this.userResponses);
        this.filter();
      }
      this.message = message;
      if (!_.isEmpty(message)) {
        this.showBack = true;
        if (
          this.message.currentId === '0015' &&
          this.commercialService.addAddress
        ) {
          if (this.deviceWidth > 768) {
            this.loadComponent(this.question[3]);
          } else {
            this.loadComponentMob(this.question[3]);
          }
        } else if (
          this.message.currentId === '0017' &&
          this.userResponses[3].fieldValue.length < 2
        ) {
          for (let i = 0; i < this.question.length; i++) {
            if (this.question[i]._id === this.message.currentId) {
              if (this.deviceWidth > 768) {
                this.loadComponent(this.question[i + 2]);
              } else {
                this.loadComponentMob(this.question[i + 2]);
              }
            }
          }
        } else if (
          this.message.currentId === '003' &&
          this.message['nextId'] === '0015' &&
          this.deviceWidth > 767
        ) {
          for (let i = 0; i < this.question.length; i++) {
            if (this.question[i]._id === this.message.nextId) {
              if (this.deviceWidth > 768) {
                this.loadComponent(this.question[i]);
              } else {
                this.loadComponentMob(this.question[i]);
              }
            }
          }
        } else {
          for (let i = 0; i < this.question.length; i++) {
            if (this.question[i]._id === this.message.currentId) {
              if (this.deviceWidth > 768) {
                this.loadComponent(this.question[i + 1]);
              } else {
                this.loadComponentMob(this.question[i + 1]);
              }
            }
          }
        }
        this.getLoaderImage(message);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (changes.questions) {
      this.question = changes.questions.currentValue;
      if (this.deviceWidth > 768) {
        if (
          !_.isEmpty(this.userResponses) &&
          !_.isEmpty(this.question) &&
          !_.isEmpty(this.commercialService.currentId)
        ) {
          for (let i = 0; i < this.question.length; i++) {
            if (this.question[i]._id === this.commercialService.currentId) {
              this.commercialService.messageService({
                currentId: this.question[i - 1]._id,
              });
            }
          }
          this.showProgress = true;
        } else {
          this.loadComponent(this.question[0]);
        }
      } else {
        this.loadComponent(this.question[0]);
      }
    }
  }

  ngAfterViewChecked(): void {
    if (this.showProgress === true) {
      this.userResponses = this.commercialService.userResponse.userResponses;
      const ids = [];
      _.each(this.userResponses, function (item) {
        ids.push(item.com_question_id);
      });
      const findService = _.findWhere(this.userResponses, {
        fieldName: 'service',
      });
      if (findService !== undefined) {
        this.commercialService.setServiceType(
          findService.fieldValue[findService.fieldValue.length - 1].value
        );
      }
      for (let i = 0; i < this.questions.length; i++) {
        if (this.questions[i]._id === this.commercialService.currentId) {
          break;
        }
        this.getLoaderImage({ currentId: ids[i] });
      }
      this.showProgress = false;
    }
    // to avoid attemp to detect destroyed changes error
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }

  loadComponent(question) {
    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(question.component);
    const viewContainerRef = this.appCommercial.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<InterfaceComponent>componentRef.instance).data = question._id;
  }

  loadComponentMob(question) {
    const viewContainerRef = this.appCommercial.viewContainerRef;
    const containerLength = viewContainerRef.length;
    if (containerLength > this.question.indexOf(question)) {
      for (let i = this.question.indexOf(question); i < containerLength; i++) {
        viewContainerRef.remove(i);
        this.cd.detach();
        // to avoid attemp to detect destroyed changes error
        if (!this.cd['destroyed']) {
          this.cd.detectChanges();
        }
      }
      const getId = document.getElementById(question._id);
      if (getId == null) {
        const componentFactory =
          this.componentFactoryResolver.resolveComponentFactory(
            question.component
          );
        const componentRef = viewContainerRef.createComponent(componentFactory);
        (<InterfaceComponent>componentRef.instance).data = question._id;
        this.cd.detach();
        // to avoid attemp to detect destroyed changes error
        if (!this.cd['destroyed']) {
          this.cd.detectChanges();
        }
      }
    } else {
      const getId = document.getElementById(question._id);
      if (getId == null) {
        const componentFactory =
          this.componentFactoryResolver.resolveComponentFactory(
            question.component
          );
        const componentRef = viewContainerRef.createComponent(componentFactory);
        (<InterfaceComponent>componentRef.instance).data = question._id;
        this.cd.detach();
        // to avoid attemp to detect destroyed changes error
        if (!this.cd['destroyed']) {
          this.cd.detectChanges();
        }
      }
    }
    this.triggerScrollTo(question._id);
  }

  public triggerScrollTo(destination) {
    const config: ScrollToConfigOptions = {
      target: destination,
      duration: 0,
      easing: 'easeOutElastic',
    };
    this._scrollToService.scrollTo(config);
  }

  back() {
    this.userResponses = this.commercialService.userResponse.userResponses;
    this.currentId = this.commercialService.currentId;
    if (this.userResponses.length > 1) {
      this.filter();
    }
    if (
      this.currentId === '0019' &&
      this.userResponses[3].fieldValue.length < 2
    ) {
      for (let i = 0; i < this.question.length; i++) {
        if (this.question[i]._id === this.currentId) {
          this.previous = this.question[i - 2];
        }
      }
    } else {
      for (let i = 0; i < this.question.length; i++) {
        if (this.question[i]._id === this.currentId) {
          this.previous = this.question[i - 1];
        }
      }
    }
    this.loadComponent(this.previous);
    if (this.previous._id === '001') {
      this.showBack = false;
    }
    this.hideLoaderImage(this.previous._id);
  }

  filter() {
    let ques;
    if (!_.isEmpty(this.commercialService.filteredQues)) {
      ques = this.commercialService.filteredQues;
      const filtered = [];
      for (let i = 0; i < this.questions.length; i++) {
        for (let j = 0; j < ques.length; j++) {
          if (this.questions[i]._id === ques[j]._id) {
            filtered.push(this.questions[i]);
          }
        }
      }
      this.question = filtered;
    } else {
      this.question = this.questions;
    }
  }

  // To load the image dynamically for loader on next action
  getLoaderImage(message) {
    if (message.currentId === '001') {
      this.showThunder = true;
    }
    this.selectedServiceType = this.commercialService.selectedType;
    if (this.selectedServiceType === 'New Service') {
      this.showNextId = true;
    } else {
      this.showNextId = false;
    }
    if (this.selectedServiceType === 'New Service') {
      // replace image src by active thunder
      if (
        message.currentId === '006' ||
        message.currentId === '0013' ||
        message.currentId === '0019'
      ) {
        const imgObj = document.getElementById('thunder' + message.currentId);
        if (imgObj) {
          imgObj['parentElement'].classList.add('active');
          imgObj['parentElement'].classList.remove('disableimg');
          imgObj['src'] = 'assets/images/commercialactivethunder.png';
        }
      } else if (message.currentId === '0023') {
        const imgObj = document.getElementById('building');
        if (imgObj) {
          imgObj['src'] = 'assets/images/commercialactivebuilding.svg';
        }
      } else if (message.currentId !== '001') {
        // replace image src by active dot
        const imgObj = document.getElementById('dot' + message.currentId);
        if (imgObj) {
          imgObj['parentElement'].classList.add('active');
          imgObj['parentElement'].classList.remove('disableimg');
          imgObj['src'] = 'assets/images/commercialactivedot.png';
        }
      }
    } else {
      // replace image src by active thunder
      if (
        message.currentId === '006' ||
        message.currentId === '0011' ||
        message.currentId === '0020'
      ) {
        const imgObj = document.getElementById('thunder' + message.currentId);
        if (imgObj) {
          imgObj['parentElement'].classList.add('active');
          imgObj['parentElement'].classList.remove('disableimg');
          imgObj['src'] = 'assets/images/commercialactivethunder.png';
        }
      } else if (message.currentId === '0023') {
        const imgObj = document.getElementById('building');
        if (imgObj) {
          imgObj['src'] = 'assets/images/commercialactivebuilding.svg';
        }
      } else if (message.currentId !== '001') {
        // replace image src by active dot
        const imgObj = document.getElementById('dot' + message.currentId);
        if (imgObj) {
          imgObj['parentElement'].classList.add('active');
          imgObj['parentElement'].classList.remove('disableimg');
          imgObj['src'] = 'assets/images/commercialactivedot.png';
        }
      }
    }
  }
  hideLoaderImage(message) {
    this.selectedServiceType = this.commercialService.selectedType;
    if (message === '001') {
      this.showThunder = false;
    }
    if (this.selectedServiceType === 'New Service') {
      // replace image src by active thunder
      if (message === '006' || message === '0013' || message === '0019') {
        const imgObj = document.getElementById('thunder' + message);
        if (imgObj) {
          imgObj['parentElement'].classList.remove('active');
          imgObj['parentElement'].classList.add('disableimg');
          imgObj['src'] = 'assets/images/disablethunder.png';
        }
      } else if (message === '0023') {
        const imgObj = document.getElementById('building');
        imgObj['parentElement'].classList.remove('active');
        imgObj['parentElement'].classList.add('disableimg');
        imgObj['src'] = 'assets/images/disablebuilding.svg';
      } else if (message !== '001') {
        // replace image src by active dot
        const imgObj = document.getElementById('dot' + message);
        if (imgObj) {
          imgObj['parentElement'].classList.remove('active');
          imgObj['parentElement'].classList.add('disableimg');
          imgObj['src'] = 'assets/images/disabledot.png';
        }
      }
    } else {
      // replace image src by active thunder
      if (message === '006' || message === '0011' || message === '0020') {
        const imgObj = document.getElementById('thunder' + message);
        if (imgObj) {
          imgObj['parentElement'].classList.remove('active');
          imgObj['parentElement'].classList.add('disableimg');
          imgObj['src'] = 'assets/images/disablethunder.png';
        }
      } else if (message === '0023') {
        const imgObj = document.getElementById('building');
        imgObj['parentElement'].classList.remove('active');
        imgObj['parentElement'].classList.add('disableimg');
        imgObj['src'] = 'assets/images/disablebuilding.svg';
      } else if (message !== '001') {
        // replace image src by active dot
        const imgObj = document.getElementById('dot' + message);
        if (imgObj) {
          imgObj['parentElement'].classList.remove('active');
          imgObj['parentElement'].classList.add('disableimg');
          imgObj['src'] = 'assets/images/disabledot.png';
        }
      }
    }
  }
}
